import { useEffect, useState } from 'react';

const QUERY = '(min-width: 1024px) and (orientation: landscape)';

/**
 * Tablet two-pane layout (Phase 16C C13, R-310): landscape at 1024 px or wider. Rotating keeps
 * state because drafts live in the repositories and the workspace stays mounted.
 */
export function useTwoPane(enabled: boolean): boolean {
  const read = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(QUERY).matches;
  const [matches, setMatches] = useState(read);
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const mq = window.matchMedia(QUERY);
    const onChange = () => setMatches(mq.matches);
    mq.addEventListener?.('change', onChange);
    window.addEventListener('resize', onChange);
    return () => {
      mq.removeEventListener?.('change', onChange);
      window.removeEventListener('resize', onChange);
    };
  }, []);
  return enabled && matches;
}
